module.exports = __webpack_public_path__ + "img/youtube.b451ffc4.svg";